import React from 'react';
import Iframe from 'react-iframe';
import { Buffer } from 'buffer';

import { EmailBodyContainer } from './styles';
import { PrivatePageStructure } from '../../../../shared/components/PrivatePageStructure';
import useWindowSize from '../../../../shared/hooks/useWindowSize';

export function EmailPreview({ closeCb, subject, html }) {
  const { height } = useWindowSize();
  const htmlIsEmpty = html === '' || !html;
  return (
    <PrivatePageStructure
      title="Visualizar Email"
      disableButtons
      enableBackButton
      backButtonCb={closeCb}
    >
      <EmailBodyContainer>
        <Iframe
          src={
            'data:text/html;base64,' +
            Buffer.from(htmlIsEmpty ? defaultHtml : html, 'utf-8').toString(
              'base64',
            )
          }
          width="100%"
          height={htmlIsEmpty ? null : height - 325} // Tricky but works :)
          frameBorder={0}
          styles={{ pointerEvents: 'none' }}
        />
      </EmailBodyContainer>
    </PrivatePageStructure>
  );
}

const defaultHtml = `
<!DOCTYPE html>
<head>
  <link href='https://fonts.googleapis.com/css?family=Source+Sans+Pro' rel='stylesheet' type='text/css'>
</head>
<body>
  <div style="display:flex;align-items:center;justify-content:center;font-family:'Source Sans Pro',sans-serif;">
    <h1>Sem dados</h1>
  </div>
</body>
</html>`;
